module.exports = __webpack_public_path__ + "static/media/team-introduction-2.2fa94da7.jpg";